import clsx from "clsx";

import { TabHeader } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";

import { ArchivedBadge } from "@components/custom/content";

import "./product-tab-header.scss";

export function ProductTabHeader({
  name,
  onTabClick,
  selected,
  productId,
  text,
  className = "",
  showIcon = false,
  isArchived = false,
}) {
  return (
    <>
      <TabHeader
        name={name}
        onTabClick={onTabClick}
        selected={selected}
        className={clsx(className, "product-tab-header")}
      >
        {showIcon && (
          <Product productId={productId} className="product-tab-header-icon" />
        )}
        <div className="product-tab-header-text">{text}</div>
        {isArchived && <ArchivedBadge />}
      </TabHeader>
    </>
  );
}
